import React, { useEffect } from "react";
import { Total } from "../../../../Components/Total";
import { Stack } from "@mui/material";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { Card } from "./Components/Card";
import { LoadReceiptCheck } from "../../../../../../../domain/usecases/load-receipt-check";
import { ReceiptCheck } from "../../../../../../../domain/models/receipt-check";
import { CardSkeleton } from "./Components/CardSkeleton";
import { LoadProductListByManyCodes } from "../../../../../../../domain/usecases/load-product-list-by-many-codes";

type Props = {
  receiptId: number;
  loadReceiptCheck: LoadReceiptCheck;
  loadProductListByManyCodes: LoadProductListByManyCodes;
  onError: () => void;
};

export const Report: React.FC<Props> = ({
  loadReceiptCheck,
  receiptId,
  loadProductListByManyCodes,
  onError,
}) => {
  const navigate = useNavigate();
  const [receiptCheck, setReceiptCheck] = React.useState<ReceiptCheck | null>(
    null
  );

  useEffect(() => {
    async function getReceiptCheck() {
      try {
        const check = await loadReceiptCheck.load(receiptId);
        const codes = check.receiptCheckItems.map((item) => item.code);
        const products = await loadProductListByManyCodes.load(codes);
        check.receiptCheckItems.forEach((item) => {
          if (item.referenceAmount === item.countedAmount) {
            const match = products.find(
              (product) => product.eanCode === item.code
            );
            if (match) {
              item.description = match.description;
              item.reference = match.reference;
            }
          }
        });
        setReceiptCheck(check);
      } catch (error) {
        console.log(error);
        onError();
      }
    }

    getReceiptCheck();
  }, []);
  return (
    <>
      <Total
        text="Total de Produtos"
        number={
          receiptCheck ? `${receiptCheck?.receiptCheckItems.length}` : "0"
        }
      />
      <Stack sx={{ m: "20px" }} spacing={4}>
        <>
          {receiptCheck ? (
            <>
              {receiptCheck?.receiptCheckItems.map((item, index) => {
                const success = item.referenceAmount === item.countedAmount;
                return (
                  <Card
                    key={index}
                    title={success ? "Suceso" : "Quantidade Incorreta"}
                    content={
                      success
                        ? `O produto ${item.description}${
                            item.batch && ", Lote " + item.batch
                          } está correto `
                        : `O produto de código ${item.code} está incorreto`
                    }
                    success={success}
                  />
                );
              })}
              <Button
                variant="contained"
                color="secondary"
                sx={{ color: "white", height: "50px", fontWeight: "bold" }}
                onClick={() => {
                  navigate("/mobile/check");
                }}
              >
                Sair
              </Button>
            </>
          ) : (
            <>
              <CardSkeleton />
              <CardSkeleton />
              <CardSkeleton />
            </>
          )}
        </>
      </Stack>
    </>
  );
};
